import { useEffect, useState } from "react";

function ua() {
  if (typeof navigator === "undefined") return "";
  return navigator.userAgent || "";
}

export function isTabletUA() {
  const u = ua();
  return /iPad|Tablet|PlayBook|Silk/i.test(u) || (/Android/i.test(u) && !/Mobile/i.test(u));
}

export function isMobilePhoneUA() {
  const u = ua();
  if (isTabletUA()) return false;
  return /iPhone|iPod|Android.*Mobile|Mobile|Windows Phone|BlackBerry|IEMobile|Opera Mini/i.test(u);
}

export function getDeviceType() {
  if (typeof window === "undefined") return "desktop";
  const w = window.innerWidth;
  const hasTouch = "ontouchstart" in window || navigator.maxTouchPoints > 0;
  if (isTabletUA()) return "tablet";
  if (isMobilePhoneUA()) return "phone";
  if (hasTouch && w <= 768) return "phone";
  if (hasTouch && w >= 769 && w <= 1024) return "tablet";
  return "desktop";
}

export function useDeviceType() {
  const [type, setType] = useState(() => getDeviceType());
  useEffect(() => {
    const onResize = () => setType(getDeviceType());
    window.addEventListener("resize", onResize);
    window.addEventListener("orientationchange", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
      window.removeEventListener("orientationchange", onResize);
    };
  }, []);
  return type;
}
